import { GetTimeFromTimestamp,LedgerImportToPriceComparison } from '@dave/types';



export class LedgerImportToPriceComparisonEntity {
    constructor(
        public Id: number = null,
        public LedgerImportId: number = null,
        public PriceComparisonIds: string = null,
        public Name: string = null,
        public PartnerId: number = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
    ) {}

    public static EntityName = 'LedgerImportToPriceComparison';
    public Clone(override: Partial<LedgerImportToPriceComparisonEntity> = {}): LedgerImportToPriceComparisonEntity {
        const attr = { ...this, ...override };
        return Object.assign(new LedgerImportToPriceComparisonEntity(), attr);
    }
}

export function LedgerImportToPriceComparisonEntityFromBackend(res: LedgerImportToPriceComparison): LedgerImportToPriceComparisonEntity {

    return new LedgerImportToPriceComparisonEntity(
        res.Id && +res.Id,
        res.LedgerImportId && +res.LedgerImportId,
        res.PriceComparisonIds,
        res.Name,
        res.PartnerId && +res.PartnerId,
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
    );
}
